import type { ChangelogEntry } from "../types";

/**
 * VIB-2725. Dokumenter-fanen mot den nye modellen: mappetre med undermapper,
 * deling fra eieren, versjonsnummer og varsel om ulagrede endringer.
 *
 * Gatet på `feature_dokumentarkiv` som resten av arkivet, så ingen får beskjed
 * om funksjoner de ikke ser ennå.
 */
export const DOKUMENTARKIV_TRE_2026_10: ChangelogEntry = {
  id: "2026-10-02-dokumentarkiv-tre",
  date: "2026-10-02",
  title: "Dokumentarkivet har fått mappetre, deling og versjonsnummer",
  summary:
    "Mapper kan ha undermapper og klappes sammen, dokumentet du åpner vises i siden, eieren kan slippe inn andre, og du får varsel hvis du går fra noe uten å lagre.",
  sections: [
    {
      heading: "Dokumentarkiv",
      items: [
        {
          title: "Mapper kan ligge inne i mapper",
          kind: "nytt",
          body: "Mappene vises nå som et tre, og en mappe med undermapper kan klappes sammen med pila foran navnet. Du ser fortsatt bare det du har tilgang til — en undermappe gir aldri mer tilgang enn mappene over seg.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Ny undermappe arver tilgangen fra mappa over",
          kind: "nytt",
          body: "Plusstegnet ved en mappe lager en undermappe under den, og lese- og endringskravene starter på det samme som mappa over. Verdiene står i skjemaet, så du kan justere dem før du lagrer.",
          featureFlag: "feature_dokumentarkiv",
          minRole: "admin",
        },
        {
          title: "Del et dokument med en kollega",
          kind: "nytt",
          body: "Eier du et dokument, får du en Del-knapp der du kan gi enkeltpersoner rett til å redigere akkurat det. De kan lagre, men ikke gi tilgangen videre, og de får ingen tilgang til resten av mappa.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Versjonsnummer som øker når du lagrer",
          kind: "nytt",
          body: "Hvert dokument viser et versjonsnummer som går opp med én hver gang tittelen eller teksten endres. Da ser du om det har skjedd noe siden du leste det sist. Tidligere versjoner lagres ikke — nummeret er en teller, ikke et arkiv.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "Varsel hvis du går fra noe uten å lagre",
          kind: "nytt",
          body: "Begynner du å skrive og klikker deg bort — til en annen mappe, et annet dokument eller en annen side — får du spørsmål først. Det samme gjelder om du lukker fanen. Ingenting lagres automatisk.",
          featureFlag: "feature_dokumentarkiv",
        },
        {
          title: "PDF-er laster først når du åpner en",
          kind: "nytt",
          body: "Koden som tegner PDF-er hentes i det øyeblikket du åpner en PDF, ikke når du går inn i arkivet. Det gjør at arkivet åpner seg raskere for alle som bare skal lese en rutine.",
          featureFlag: "feature_dokumentarkiv",
        },
      ],
    },
  ],
};
